import { useLocation } from "react-router-dom";
import { useSiteSettings, buildWhatsAppLink } from "@/lib/SiteSettingsContext";

export default function WhatsAppFloatingButton() {
    const location = useLocation();
    const { settings, hasWhatsApp } = useSiteSettings();

    if (location.pathname.startsWith("/admin")) return null;
    if (!hasWhatsApp) return null;

    const href = buildWhatsAppLink(
        settings.whatsapp_number,
        settings.whatsapp_default_message,
    );
    if (!href) return null;

    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Chat with Omega IT Ltd on WhatsApp"
            data-testid="whatsapp-floating-button"
            className="fixed bottom-5 right-5 z-40 group"
        >
            <span className="absolute inset-0 rounded-full bg-emerald-500/40 blur-xl opacity-0 group-hover:opacity-100 transition-opacity"></span>
            <span className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg flex items-center justify-center transition-transform group-hover:scale-105">
                <svg
                    viewBox="0 0 32 32"
                    className="w-7 h-7"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M16 .39A15.6 15.6 0 0 0 .39 16a15.6 15.6 0 0 0 2.32 8.21L.6 31.6l7.6-2.05A15.6 15.6 0 0 0 31.61 16 15.6 15.6 0 0 0 16 .39Zm0 28.4a13 13 0 0 1-6.6-1.8l-.47-.28-4.5 1.22 1.2-4.39-.3-.46A12.93 12.93 0 1 1 29 16a13 13 0 0 1-13 12.79Zm7.36-9.6c-.4-.2-2.36-1.17-2.72-1.3-.37-.13-.64-.2-.9.2-.27.4-1.03 1.3-1.27 1.56-.23.27-.47.3-.86.1-.4-.2-1.68-.62-3.2-1.97a12 12 0 0 1-2.21-2.74c-.23-.4-.03-.61.17-.81.18-.18.4-.46.6-.7.2-.23.27-.4.4-.66.13-.27.07-.5-.03-.7-.1-.2-.9-2.17-1.23-2.97-.32-.78-.65-.67-.9-.68l-.76-.01a1.46 1.46 0 0 0-1.06.5 4.46 4.46 0 0 0-1.4 3.31c0 1.95 1.43 3.84 1.63 4.1.2.27 2.82 4.31 6.84 6.04.96.41 1.7.66 2.28.85.95.3 1.82.26 2.5.16.76-.11 2.36-.96 2.69-1.89.33-.93.33-1.72.23-1.89-.1-.17-.36-.27-.76-.47Z" />
                </svg>
            </span>
        </a>
    );
}
